import i18n from "@/i18n";
import {
  IContractProductProvider,
  IProvisioningProvider
} from "@/models/providers/contractProduct";
import { IMenuRoute } from "@/models/routes";

const isActive: IMenuRoute["isActive"] = (currentRoute, isActive) => {
  if ((currentRoute.name || "").match(/__(cancelled|active)/g)) return false;
  return isActive;
};

export function ClientProductsTabigation() {
  return [
    {
      label: i18n.t("_.active"),
      to: {
        name: "client__activeProducts"
      }
    },
    {
      label: i18n.t("_.cancelled"),
      to: {
        name: "client__cancelledProducts"
      }
    },
    {
      isActive,
      label: i18n.t("_.all"),
      to: {
        name: "client__allProducts"
      }
    }
  ];
}

export function ClientSubscriptionsTabigation() {
  return [
    {
      label: i18n.t("_.active"),
      to: {
        name: "client__activeSubscriptions"
      }
    },
    {
      label: i18n.t("_.cancelled"),
      to: {
        name: "client__cancelledSubscriptions"
      }
    },
    {
      isActive,
      label: i18n.t("_.all"),
      to: {
        name: "client__allSubscriptions"
      }
    }
  ];
}

export function ClientOneTimePurchasesTabigation() {
  return [
    {
      label: i18n.t("_.active"),
      to: {
        name: "client__activeOneTimePurchases"
      }
    },
    {
      label: i18n.t("_.cancelled"),
      to: {
        name: "client__cancelledOneTimePurchases"
      }
    },
    {
      isActive,
      label: i18n.t("_.all"),
      to: {
        name: "client__allOneTimePurchases"
      }
    }
  ];
}

export function ClientCategoryProductsTabigation() {
  return [
    {
      label: i18n.t("_.active"),
      to: {
        name: "client__activeCategoryProducts"
      }
    },
    {
      label: i18n.t("_.cancelled"),
      to: {
        name: "client__cancelledCategoryProducts"
      }
    },
    {
      isActive,
      label: i18n.t("_.all"),
      to: {
        name: "client__allCategoryProducts"
      }
    }
  ];
}

export function cProdTabigation({
  $cProdData,
  $cProdProvData
}: {
  $cProdData: IContractProductProvider;
  $cProdProvData: IProvisioningProvider;
}) {
  return [
    {
      label: i18n.t("_.overview"),
      to: {
        name: `clientCProdOverview`
      }
    },
    {
      label: i18n.t("_.invoices"),
      to: {
        name: `clientCProdInvoices`
      }
    },
    {
      label: i18n.t("_.credit_notes"),
      to: {
        name: `clientCProdCreditNotes`
      }
    },
    {
      label: i18n.t("_.manage"),
      to: {
        name: `clientCProdProvisioning`
      },
      if: () => {
        return $cProdProvData.canManageProvisioning;
      }
    },
    {
      label: i18n.t("_.settings"),
      to: {
        name: `clientCProdSettings`
      },
      if: () => {
        return $cProdData.canModifySettings;
      }
    },
    {
      label: i18n.t("_.delegates"),
      to: {
        name: `clientCProdDelegates`
      },
      if: () => {
        return !$cProdData.isDelegatedAccess;
      }
    }
  ];
}
